import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const RefreshButtonText = styled.span`
  font-weight: 900;
  color: black;

  &:hover {
    color: ${colours.elexonBlue};
  }
`;

export const RefreshButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${colours.elexonBlack};

  background: none;
  border: none;
  border-radius: 2px;
  padding: 0;
  font: inherit;

  &:disabled {
    color: ${colours.mediumGrey};
    cursor: default;
  }

  &:hover:not(:disabled) {
    cursor: pointer;
  }

  .icon {
    font-family: elexon-icons;
    color: ${colours.elexonBlue};
    border: 1px solid ${colours.elexonBlue};
    border-radius: 4px;
    background: transparent;
    padding: 2px;
    transition: background-color 350ms ease-in-out;
  }

  &:hover:not(:disabled) .icon {
    background: ${colours.elexonBlue};
    color: ${colours.white};
    border-color: ${colours.elexonBlue};
  }

  &:hover:not(:disabled) ${RefreshButtonText} {
    color: ${colours.elexonBlue};
  }
`;

export const RefreshErrorContainer = styled.div`
  display: flex;
  align-items: center;

  color: ${colours.darkRed};
  font-size: ${fonts.xSmall};
`;
